import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Services',
  href: '#services'
}, {
  name: 'Process',
  href: '#process'
}, {
  name: 'Products',
  href: '#products'
}, {
  name: 'Retail Network',
  href: '#retail-network'
}, {
  name: 'Case Studies',
  href: '#case-studies'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const {
    scrollY
  } = useScroll();
  const navBackground = useTransform(scrollY, [0, 50], ['rgba(10, 22, 40, 0)', 'rgba(10, 22, 40, 0.9)']);
  const navBackdropBlur = useTransform(scrollY, [0, 50], ['blur(0px)', 'blur(12px)']);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      // Determine active section
      const sections = navLinks.map(link => link.href.substring(1));
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const targetId = href.substring(1);
    const element = document.getElementById(targetId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav style={{
    backgroundColor: navBackground,
    backdropFilter: navBackdropBlur
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'border-white/10' : 'border-transparent'}`} data-id="element-403">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-404">
        <div className="flex items-center justify-between h-20" data-id="element-405">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer group" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-406">
            <div className="flex items-center gap-2" data-id="element-407">
              <div className="bg-[#d4a853] text-[#0a1628] font-bold text-2xl px-3 py-1.5 rounded" data-id="element-408">
                888
              </div>
              <div className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-409">
                Sourcing
                <br data-id="element-410" />
                Limited
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block" data-id="element-411">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-412">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleLinkClick(e, link.href)} className={`relative group px-3 py-2 text-sm font-medium transition-colors uppercase tracking-wide ${activeSection === link.href.substring(1) ? 'text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-413">
                  {link.name}
                  <span className={`absolute bottom-0 left-0 h-0.5 bg-[#d4a853] transition-all duration-300 ${activeSection === link.href.substring(1) ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-414" />
                </a>)}
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-415">
            <motion.a href="#contact" onClick={e => handleLinkClick(e, '#contact')} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-[#d4a853] text-[#0a1628] px-6 py-2.5 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300 inline-block" data-id="element-416">
              Get a Quote
            </motion.a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-417">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-418">
              {isMobileMenuOpen ? <X size={24} data-id="element-419" /> : <Menu size={24} data-id="element-420" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-421">
        {isMobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="md:hidden bg-[#0a1628] border-b border-white/10 overflow-hidden" data-id="element-422">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-423">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleLinkClick(e, link.href)} className={`block px-3 py-4 text-base font-medium border-b border-white/5 ${activeSection === link.href.substring(1) ? 'text-[#d4a853]' : 'text-gray-300 hover:text-white'}`} data-id="element-424">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={e => handleLinkClick(e, '#contact')} className="block w-full mt-4 bg-[#d4a853] text-[#0a1628] px-6 py-3 text-sm font-bold uppercase tracking-wider text-center" data-id="element-425">
                Get a Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}